/* BAF Saat — saat bulucu: çip seçimi → koleksiyon filtre URL'i + canlı sonuç sayısı. */
if (!customElements.get('bs-saat-bulucu')) {
  customElements.define(
    'bs-saat-bulucu',
    class extends HTMLElement {
      connectedCallback() {
        this.secim = {};
        this.istek = null;
        this.addEventListener('click', (e) => {
          const cip = e.target.closest('[data-grup]');
          if (!cip) return;
          const grup = cip.dataset.grup;
          const acik = cip.getAttribute('aria-pressed') === 'true';
          this.querySelectorAll(`[data-grup="${grup}"]`).forEach((b) => b.setAttribute('aria-pressed', 'false'));
          if (acik) delete this.secim[grup];
          else {
            cip.setAttribute('aria-pressed', 'true');
            this.secim[grup] = cip.dataset.deger;
          }
          this.guncelle();
        });
      }

      url(gorunum) {
        const koleksiyon = this.secim.koleksiyon || this.dataset.koleksiyon || 'all';
        const p = new URLSearchParams();
        if (this.secim.mekanizma) p.append('filter.p.m.custom.mekanizma', this.secim.mekanizma);
        if (this.secim.butce) {
          const [alt, ust] = this.secim.butce.split('-');
          if (alt && Number(alt) > 0) p.append('filter.v.price.gte', alt);
          if (ust) p.append('filter.v.price.lte', ust);
        }
        if (gorunum) p.append('view', gorunum);
        const q = p.toString();
        return `${this.dataset.kok}/${koleksiyon}${q ? `?${q}` : ''}`;
      }

      guncelle() {
        const git = this.querySelector('[data-sb-git]');
        const metin = this.querySelector('[data-sb-metin]');
        git.href = this.url();
        /* Metinler snippets/bs-saat-bulucu.liquid data-metin-* özniteliklerinden (dil dosyası); yoksa Türkçe yedek */
        const bos = this.dataset.metinBos || 'Saatleri göster';
        if (!Object.keys(this.secim).length) {
          metin.textContent = bos;
          return;
        }
        if (this.istek) this.istek.abort();
        this.istek = new AbortController();
        git.setAttribute('aria-busy', 'true');
        fetch(this.url('bs-sayac'), { signal: this.istek.signal })
          .then((r) => r.text())
          .then((t) => {
            const n = JSON.parse(t.trim()).n;
            const sablon = (Number(n) === 1 ? this.dataset.metinTek : this.dataset.metinCok) || '# saati göster';
            metin.textContent = sablon.replace('#', Number(n).toLocaleString('tr-TR'));
          })
          .catch((err) => {
            if (err.name !== 'AbortError') metin.textContent = bos;
          })
          .finally(() => git.removeAttribute('aria-busy'));
      }
    }
  );
}
